function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillOpacity: 0.101,
  d: "M20 0C8.96 0 0 8.96 0 20s8.96 20 20 20 20-8.96 20-20S31.04 0 20 0zm7.22 12.68a3.85 3.85 0 013.86 3.86 3.85 3.85 0 01-3.86 3.86 3.85 3.85 0 01-3.86-3.86c-.02-2.14 1.72-3.86 3.86-3.86zm-12-3.16c2.6 0 4.72 2.12 4.72 4.72 0 2.6-2.12 4.72-4.72 4.72-2.6 0-4.72-2.12-4.72-4.72 0-2.62 2.1-4.72 4.72-4.72zm0 18.26v7.5c-4.8-1.5-8.6-5.2-10.28-9.92 2.1-2.24 7.34-3.38 10.28-3.38 1.06 0 2.4.16 3.8.44-3.28 1.74-3.8 4.04-3.8 5.36zM20 36c-.54 0-1.06-.02-1.58-.08v-8.14c0-2.84 5.88-4.26 8.8-4.26 2.14 0 5.84.78 7.68 2.3C32.56 31.76 26.78 36 20 36z"
});

var SvgIcoClient = function SvgIcoClient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoClient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-client.1928beed.svg";
export { ForwardRef as ReactComponent };